import { render, staticRenderFns } from "./AmDataTable.vue?vue&type=template&id=01f8a6f3&scoped=true&"
import script from "./AmDataTable.vue?vue&type=script&lang=js&"
export * from "./AmDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f8a6f3",
  null
  
)

export default component.exports